import { StackScreenProps } from "@react-navigation/stack";
import React from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useStoreHighlightById } from "@/hooks/domain/storeHighlights";
import { HomeNavigation, HomeStackParamList } from "@/navigation/stacks/HomeStack";

import StoreHighlightMobile from "./StoreHighlight.mobile";
import StoreHighlightWeb from "./StoreHighlight.web";

type ScreenProps = StackScreenProps<HomeStackParamList, "storeHighlight">;

const StoreHighlight = ({ route }: ScreenProps) => {
  const hightlightId = route?.params?.highlightId;

  const { isWebMode } = useViewport();
  const { goBack, navigate, replace, setOptions } = useAppNavigation<HomeNavigation>();

  const { data, isLoading } = useStoreHighlightById(hightlightId, {
    enabled: !!hightlightId,
    onSuccess: (hightligh) => {
      if (hightligh.corredor?._id) {
        replace("hallCategoryList", {
          hallId: hightligh.corredor?._id,
        });
      } else {
        setOptions({ title: hightligh.descricao });
      }
    },
    onError: () => {
      if (!hightlightId) {
        goBack();
      }
    },
  });

  const onSelectProduct = (productId: string) => {
    navigate("product", { productId });
  };

  const Screen = isWebMode ? StoreHighlightWeb : StoreHighlightMobile;

  return (
    <Screen
      highlight={data}
      isLoading={isLoading}
      onGoBack={goBack}
      onSelectProduct={onSelectProduct}
    />
  );
};

export default StoreHighlight;
